import React, {Component} from 'react';

import '../../styles/elements/titleText.css';

class TitleText extends Component {
    render() {
        return (
            <div className={'title-text' + (this.props.className ? ' ' + this.props.className : '')}>
                <div className="title-text__text">
                    <div className="title-text__text-container">
                        {this.props.content}
                    </div>
                </div>
                <div className="title-text__title-container">
                   <h2 className="title-text__title">{ this.props.title }</h2>
                </div>
            </div>
        )
    }


}

export default TitleText;



// WEBPACK FOOTER //
// ./src/js/elements/TitleText.js